import { profilesParameters } from "./types";

export const profilesKeys = {
  all: () => ["profiles"] as const,
  list: (filters: Partial<profilesParameters>) =>
    [...profilesKeys.all(), filters] as const,
};
